import de from './de.translations.json.js';
import en from './en.translations.json.js';
import es from './es.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import nl from './nl.translations.json.js';
import { factsheetHeaderTranslationsDe, factsheetHeaderTranslationsEn, factsheetHeaderTranslationsEs, factsheetHeaderTranslationsFr, factsheetHeaderTranslationsIt, factsheetHeaderTranslationsNl } from '../factsheet-header/index.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';

const portfolioTransactionAddTranslationsDe = { ...de, ...factsheetHeaderTranslationsDe, ...localizationSupportTranslationsDe };
const portfolioTransactionAddTranslationsEn = { ...en, ...factsheetHeaderTranslationsEn, ...localizationSupportTranslationsEn };
const portfolioTransactionAddTranslationsEs = { ...es, ...factsheetHeaderTranslationsEs, ...localizationSupportTranslationsEs };
const portfolioTransactionAddTranslationsFr = { ...fr, ...factsheetHeaderTranslationsFr, ...localizationSupportTranslationsFr };
const portfolioTransactionAddTranslationsIt = { ...it, ...factsheetHeaderTranslationsIt, ...localizationSupportTranslationsIt };
const portfolioTransactionAddTranslationsNl = { ...nl, ...factsheetHeaderTranslationsNl, ...localizationSupportTranslationsNl };
const portfolioTransactionAddTranslationsBundle = {
  de: portfolioTransactionAddTranslationsDe,
  en: portfolioTransactionAddTranslationsEn,
  es: portfolioTransactionAddTranslationsEs,
  fr: portfolioTransactionAddTranslationsFr,
  it: portfolioTransactionAddTranslationsIt,
  nl: portfolioTransactionAddTranslationsNl
};

export { portfolioTransactionAddTranslationsBundle, portfolioTransactionAddTranslationsDe, portfolioTransactionAddTranslationsEn, portfolioTransactionAddTranslationsEs, portfolioTransactionAddTranslationsFr, portfolioTransactionAddTranslationsIt, portfolioTransactionAddTranslationsNl };
